/* ==========================================================================
   Bulk Catering Order Modal
   Renders the catering range as full-width rows with CVP quantity swatches,
   then adds every selection to the cart in a single /cart/add.js call.
   Data is injected by sections/bulk-catering-order.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var MONEY = '${{amount}}';

  var DIET_LABELS = { GF: 'Gluten Free', DF: 'Dairy Free', V: 'Vegetarian', VG: 'Vegan' };

  function normalise(data) {
    var prices = data.prices || {};
    (data.products || []).forEach(function (p) {
      var s1 = p.step1 || {};
      p.options = (s1.options || []).map(function (o) {
        var meta = prices[o.handle] || {};
        return {
          label: o.name_override || o.handle,
          handle: o.handle,
          price: meta.price || 0,
          variantId: meta.variantId || 0
        };
      });
      if (p.step2 && p.step2.options) {
        p.split = {
          name: p.step2.name || 'Options',
          label: p.step2.label || 'Split your quantity',
          increment: p.step2.increment || 1,
          options: p.step2.options.map(function (o) {
            var meta = prices[o.handle] || {};
            return {
              label: o.name_override || o.handle,
              handle: o.handle,
              price: meta.price || 0,
              variantId: meta.variantId || 0
            };
          })
        };
      }
    });
    return data;
  }

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    if (MONEY.indexOf('amount_no_decimals') > -1) value = Math.round(cents / 100).toString();
    return '$' + value;
  }
  function groupId() {
    return 'cvp_' + Math.random().toString(36).slice(2, 16);
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function BulkCateringOrder(root) {
    this.root = root;
    this.data = normalise(JSON.parse(root.querySelector('[data-bco-data]').textContent));
    if (this.data.moneyFormat) MONEY = this.data.moneyFormat;
    this.modal = root.querySelector('[data-bco-modal]');
    this.body = root.querySelector('[data-bco-body]');
    this.filters = root.querySelector('[data-bco-filters]');
    this.summary = root.querySelector('[data-bco-summary]');
    this.submit = root.querySelector('[data-bco-submit]');
    this.error = root.querySelector('[data-bco-error]');
    this.state = {};
    this.build();
    this.bind();
  }

  /* ---------------- build ---------------- */

  BulkCateringOrder.prototype.build = function () {
    var self = this;
    var groups = {};
    var order = [];

    this.data.products.forEach(function (p) {
      var g = p.group || 'Other';
      if (!groups[g]) { groups[g] = []; order.push(g); }
      groups[g].push(p);
    });

    order.forEach(function (name) {
      var wrap = el('div', 'bco-group');
      wrap.setAttribute('data-bco-group', name);
      wrap.appendChild(el('div', 'bco-group__label', name));
      groups[name].forEach(function (p) { wrap.appendChild(self.row(p)); });
      self.body.appendChild(wrap);
    });
  };

  BulkCateringOrder.prototype.row = function (p) {
    var self = this;
    var item = el('div', 'bco-item');
    item.setAttribute('data-bco-item', p.handle);
    item.setAttribute('data-diets', (p.diets || []).join('|'));

    var media = el('div', 'bco-item__media');
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title;
      img.loading = 'lazy';
      media.appendChild(img);
      self.bindPreview(media, p.image, p.title);
    }
    item.appendChild(media);

    var info = el('div', 'bco-item__info');
    info.appendChild(el('h3', 'bco-item__title', p.title));
    if (p.description) info.appendChild(el('p', 'bco-item__desc', p.description));

    if (p.diets && p.diets.length) {
      var badges = el('ul', 'bco-item__diets');
      p.diets.forEach(function (d) {
        var li = el('li', 'bco-item__diet', d + '<span class="bco-item__diet-tip">' + (DIET_LABELS[d] || d) + '</span>');
        li.setAttribute('tabindex', '0');
        badges.appendChild(li);
      });
      item.appendChild(badges);
    }

    /* quantity swatches */
    var qty = el('div', 'bco-qty');
    p.options.forEach(function (opt) {
      var btn = el('button', 'bco-qty__btn');
      btn.type = 'button';
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('data-qty', opt.label);
      btn.setAttribute('data-cents', opt.price);
      btn.innerHTML = opt.label + '<span class="bco-qty__tip">' + money(opt.price) + '</span>';
      btn.addEventListener('click', function () { self.select(p, opt, item); });
      qty.appendChild(btn);
    });

    var clear = el('button', 'bco-clear', 'Clear');
    clear.type = 'button';
    clear.hidden = true;
    clear.setAttribute('data-bco-clear', '');
    clear.addEventListener('click', function () { self.clear(p, item); });
    qty.appendChild(clear);
    info.appendChild(qty);

    /* conditional split (e.g. tea sandwich bread) */
    if (p.split) {
      var split = el('div', 'bco-split');
      split.hidden = true;
      split.setAttribute('data-bco-split', '');
      split.appendChild(el('p', 'bco-split__hint', p.split.label));

      var row = el('div', 'bco-split__row');
      p.split.options.forEach(function (o, i) {
        var opt = el('label', 'bco-split__opt');
        opt.appendChild(el('span', null, o.label));
        var sel = document.createElement('select');
        sel.setAttribute('data-split-option', o.label);
        sel.addEventListener('change', function () { self.splitChanged(p, item); });
        opt.appendChild(sel);
        row.appendChild(opt);
        if (i === 0) sel.setAttribute('data-split-first', '');
      });

      var tally = el('span', 'bco-split__tally');
      tally.setAttribute('data-split-tally', '');
      row.appendChild(tally);
      split.appendChild(row);
      info.appendChild(split);
    }

    item.appendChild(info);
    return item;
  };

  /* ---------------- image hover preview ---------------- */

  BulkCateringOrder.prototype.preview = function () {
    if (!this._preview) {
      var box = el('div', 'bco-preview');
      box.innerHTML = '<img alt="">';
      document.body.appendChild(box);
      this._preview = box;
    }
    return this._preview;
  };

  BulkCateringOrder.prototype.bindPreview = function (media, src, alt) {
    var self = this;

    function place(e) {
      var box = self.preview();
      var pad = 16;
      var w = box.offsetWidth || 260;
      var h = box.offsetHeight || 260;
      var x = e.clientX + pad;
      var y = e.clientY - h / 2;
      if (x + w > window.innerWidth - pad) x = e.clientX - w - pad;
      if (y < pad) y = pad;
      if (y + h > window.innerHeight - pad) y = window.innerHeight - h - pad;
      box.style.left = x + 'px';
      box.style.top = y + 'px';
    }

    media.addEventListener('mouseenter', function (e) {
      var box = self.preview();
      var img = box.querySelector('img');
      if (img.getAttribute('src') !== src) img.src = src;
      img.alt = alt || '';
      place(e);
      box.classList.add('is-visible');
    });

    media.addEventListener('mousemove', place);

    media.addEventListener('mouseleave', function () {
      self.preview().classList.remove('is-visible');
    });
  };

  /* ---------------- selection ---------------- */

  BulkCateringOrder.prototype.select = function (p, opt, item) {
    var current = this.state[p.handle];
    if (current && current.label === opt.label) { this.clear(p, item); return; }

    this.state[p.handle] = {
      product: p,
      label: opt.label,
      qty: parseInt(opt.label, 10),
      price: opt.price,
      option: opt,
      split: null
    };

    item.querySelectorAll('.bco-qty__btn').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-qty') === opt.label));
    });
    item.classList.add('is-selected');
    item.querySelector('[data-bco-clear]').hidden = false;

    if (p.split) this.buildSplit(p, item);
    this.refresh();
  };

  BulkCateringOrder.prototype.clear = function (p, item) {
    delete this.state[p.handle];
    item.querySelectorAll('.bco-qty__btn').forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    item.classList.remove('is-selected');
    item.querySelector('[data-bco-clear]').hidden = true;
    var split = item.querySelector('[data-bco-split]');
    if (split) split.hidden = true;
    this.refresh();
  };

  BulkCateringOrder.prototype.buildSplit = function (p, item) {
    var entry = this.state[p.handle];
    var split = item.querySelector('[data-bco-split]');
    var selects = split.querySelectorAll('select');
    var total = entry.qty;
    var step = p.split.increment || 1;

    selects.forEach(function (sel, idx) {
      var previous = parseInt(sel.value, 10);
      sel.innerHTML = '';
      for (var v = 0; v <= total; v += step) {
        var o = document.createElement('option');
        o.value = String(v);
        o.textContent = String(v);
        sel.appendChild(o);
      }
      if (!isNaN(previous) && previous <= total) sel.value = String(previous);
      else sel.value = idx === 0 ? String(total) : '0';
    });

    split.hidden = false;
    this.splitChanged(p, item);
  };

  BulkCateringOrder.prototype.splitChanged = function (p, item) {
    var entry = this.state[p.handle];
    if (!entry) return;

    var split = item.querySelector('[data-bco-split]');
    var tally = split.querySelector('[data-split-tally]');
    var parts = [];
    var sum = 0;

    split.querySelectorAll('select').forEach(function (sel) {
      var v = parseInt(sel.value, 10) || 0;
      sum += v;
      if (v > 0) {
        var label = sel.getAttribute('data-split-option');
        var meta = (p.split.options || []).filter(function (o) { return o.label === label; })[0] || {};
        parts.push({ label: label, qty: v, variantId: meta.variantId || 0, price: meta.price || 0 });
      }
    });

    entry.split = { parts: parts, valid: sum === entry.qty, sum: sum };
    tally.textContent = sum + ' / ' + entry.qty + (sum === entry.qty ? ' \u2713' : '');
    tally.classList.toggle('is-invalid', sum !== entry.qty);
    this.refresh();
  };

  /* ---------------- footer ---------------- */

  BulkCateringOrder.prototype.lineTotal = function (entry) {
    var total = entry.price;
    if (entry.split && entry.split.parts) {
      entry.split.parts.forEach(function (part) { total += (part.price || 0) * part.qty; });
    }
    return total;
  };

  BulkCateringOrder.prototype.refresh = function () {
    var keys = Object.keys(this.state);
    var total = 0;
    var valid = true;

    keys.forEach(function (k) {
      var e = this.state[k];
      total += this.lineTotal(e);
      if (e.product.split && (!e.split || !e.split.valid)) valid = false;
    }, this);

    this.summary.innerHTML = keys.length
      ? keys.length + ' item' + (keys.length === 1 ? '' : 's') + ' selected &nbsp;&middot;&nbsp; <strong>' + money(total) + '</strong>'
      : 'No items selected yet';

    this.submit.disabled = !keys.length || !valid;
    this.error.hidden = true;
  };

  /* ---------------- filters ---------------- */

  BulkCateringOrder.prototype.filter = function (value) {
    this.filters.querySelectorAll('.bco-filter').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === value));
    });

    this.body.querySelectorAll('[data-bco-item]').forEach(function (item) {
      var diets = (item.getAttribute('data-diets') || '').split('|');
      item.hidden = !(value === 'all' || diets.indexOf(value) > -1);
    });

    this.body.querySelectorAll('[data-bco-group]').forEach(function (g) {
      g.hidden = !g.querySelector('[data-bco-item]:not([hidden])');
    });
  };

  /* ---------------- cart ---------------- */

  BulkCateringOrder.prototype.payload = function () {
    var items = [];
    var self = this;
    var counter = 0;

    Object.keys(this.state).forEach(function (handle) {
      var e = self.state[handle];
      var p = e.product;
      var group = groupId();
      var productRef = 'bco' + (++counter) + Math.random().toString(36).slice(2, 6);
      var meta = { Quantity: String(e.qty) };
      var props = { Quantity: String(e.qty) };

      /* child: the quantity price product */
      if (e.option && e.option.variantId) {
        items.push({
          id: e.option.variantId,
          quantity: 1,
          properties: {
            _ParentProductID: productRef,
            _Child: 'true',
            '_group-data': 'type:child;group:' + group
          }
        });
      }

      /* children: conditional split options, one line per option */
      if (p.split && e.split && e.split.parts.length) {
        e.split.parts.forEach(function (part) {
          if (!part.variantId) return;
          items.push({
            id: part.variantId,
            quantity: part.qty,
            properties: {
              _ParentProductID: productRef,
              _Child: 'true',
              '_group-data': 'type:child;group:' + group
            }
          });
        });

        var summary = e.split.parts.map(function (part) {
          return part.qty + 'x ' + part.label;
        }).join(', ');
        props[p.split.name] = summary;
        meta[p.split.name] = summary;
      }

      meta.Bundles = '1';
      if (p.deliveryLabel) meta['__delivery-label'] = true;

      props._ProductPrice = (self.lineTotal(e) / 100).toFixed(2);
      props._ProductID = productRef;
      props['_group-data'] = 'type:parent;group:' + group + ';meta:' + encodeURIComponent(JSON.stringify(meta));

      items.push({ id: p.variantId, quantity: 1, properties: props });
    });

    return items;
  };

  BulkCateringOrder.prototype.addToCart = function () {
    var self = this;
    var items = this.payload();
    if (!items.length) return;

    this.submit.disabled = true;
    this.submit.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        self.close();
        self.reset();
        self.openCart();
      })
      .catch(function (err) {
        self.error.textContent = err.message;
        self.error.hidden = false;
      })
      .finally(function () {
        self.submit.textContent = self.submit.getAttribute('data-label') || 'Add all to cart';
        self.refresh();
      });
  };

  BulkCateringOrder.prototype.openCart = function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () { drawer.open(); }, 200);
      return;
    }
    window.location = '/cart';
  };

  BulkCateringOrder.prototype.reset = function () {
    var self = this;
    Object.keys(this.state).forEach(function (handle) {
      var item = self.body.querySelector('[data-bco-item="' + handle + '"]');
      if (item) self.clear(self.state[handle].product, item);
    });
    this.state = {};
    this.refresh();
  };

  /* ---------------- open / close ---------------- */

  BulkCateringOrder.prototype.open = function () {
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  BulkCateringOrder.prototype.close = function () {
    this.modal.hidden = true;
    document.body.style.overflow = '';
  };

  BulkCateringOrder.prototype.bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-bco-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(); });
    });
    document.querySelectorAll('[data-bco-open-global]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(); });
    });
    this.root.querySelectorAll('[data-bco-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.modal.hidden) self.close();
    });

    this.filters.querySelectorAll('.bco-filter').forEach(function (b) {
      b.addEventListener('click', function () { self.filter(b.getAttribute('data-filter')); });
    });

    this.root.querySelector('[data-bco-reset]').addEventListener('click', function () { self.reset(); });
    this.submit.addEventListener('click', function () { self.addToCart(); });

    this.refresh();
  };

  function init() {
    document.querySelectorAll('[data-bulk-catering-order]').forEach(function (root) {
      if (root.__bcoReady) return;
      root.__bcoReady = true;
      new BulkCateringOrder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
}());
